import { createSlice } from '@reduxjs/toolkit';

/** @type {DealerInfoState} */
const initialState = {
	accountName: null,
	accountAddress: null,
	accountCity: null,
	accountState: null,
	accountPostalCode: null,
	departments: [], // DealerDepartment[] — pre-filtered, no null phones
	addressLine1: null, // e.g. "1 Howard St."
	addressLine2: null, // e.g. "Burlington VT 05401"
	mapsQuery: null, // pre-formatted string for Google Maps URL
	accountId: null // used for phone-swapping data-account-ref attributes
};

const dealerInfoSlice = createSlice({
	name: 'dealerInfo',
	initialState,
	reducers: {
		/* eslint-disable no-param-reassign --
		   RTK's createSlice uses Immer internally, so returning a new object
		   (spread merge) is the intended API for a full-replace reducer. */
		setDealerInfo(state, { payload }) {
			return { ...state, ...payload };
		}
		/* eslint-enable no-param-reassign */
	}
});

export const { setDealerInfo } = dealerInfoSlice.actions;
export default dealerInfoSlice.reducer;
